import { Col, Divider, Flex, Row } from 'antd'
import React, { useEffect, useState } from 'react'

import Page from '@/components/shared/page'
import { FeatureKey } from '@/constants/feature-key'
import { ChatterOverviewSales as ChatterOverviewSalesModel } from '@/model/analytics'
import { readChatterOverviewSales } from '@/redux/chatter-reports-actions'
import { readAllEmployees } from '@/redux/employee-actions'
import { useAppDispatch } from '@/redux/utils'

import s from './chatter-reports.module.css'
import ChatterOverviewComparison from './components/chatter-overview/chatter-overview-comparison'
import ChatterOverviewSales from './components/chatter-overview/chatter-overview-sales'
import ChatterOverviewSalesRanking from './components/chatter-overview/chatter-overview-sales-ranking'
import ChatterOverviewStatistics from './components/chatter-overview/chatter-overview-statistics'
import { ReportsPageProps } from './hooks/use-report-search'

export default function CreatorReportsOverview(props: ReportsPageProps) {
  const [chatterSalesFetching, setChatterSalesFetching] = useState(false)
  const [chatterSalesReport, setChatterSalesReport] = useState<ChatterOverviewSalesModel | undefined>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    void dispatch(
      readAllEmployees({ permissionKey: FeatureKey.ChatterReportsOverview }),
    )
  }, [dispatch])

  useEffect(() => {
    const loadChatterSalesReport = async () => {
      setChatterSalesFetching(true)
      const result = await dispatch(readChatterOverviewSales({
        ...props.searchValues,
        permissionKey: FeatureKey.ChatterReportsOverview,
      })).unwrap()
      setChatterSalesReport(result)
      setChatterSalesFetching(false)
    }
    void loadChatterSalesReport()
  }, [dispatch, props.searchValues])

  return (
    <Page hideHeader contentClassName={s.chatterReportsOverview}>
      <Flex vertical>
        <ChatterOverviewSales
          loading={chatterSalesFetching}
          salesDetails={chatterSalesReport?.details}
        />
        <Divider />
        <Row>
          <Col span={18}>
            <ChatterOverviewComparison {...props} />
          </Col>
          <Col span={6}>
            <ChatterOverviewSalesRanking
              loading={chatterSalesFetching}
              rankings={chatterSalesReport?.rankings}
            />
          </Col>
        </Row>
        <Divider />
        <ChatterOverviewStatistics {...props} />
      </Flex>
    </Page>
  )
}
